import { render, staticRenderFns } from "./EditRatesModal.vue?vue&type=template&id=246d22d9&scoped=true"
import script from "./editRatesModal.ts?vue&type=script&lang=ts&external"
export * from "./editRatesModal.ts?vue&type=script&lang=ts&external"
import style0 from "./EditRatesModal.vue?vue&type=style&index=0&id=246d22d9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246d22d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('246d22d9')) {
      api.createRecord('246d22d9', component.options)
    } else {
      api.reload('246d22d9', component.options)
    }
    module.hot.accept("./EditRatesModal.vue?vue&type=template&id=246d22d9&scoped=true", function () {
      api.rerender('246d22d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/btn-edit-rates/editRatesModal/EditRatesModal.vue"
export default component.exports